// Anschrift als Text (wie im Briefkopf, lib/dokumente/briefDaten.ts anschriftText) → Empfänger-Felder der E-POST.
import type { Empfaenger } from '../../supabase/functions/epost-brief/logik';

/**
 * Letzte Zeile „PLZ Ort“ (Inland) bzw. „PLZ Ort“ + Länderzeile in Großbuchstaben (Ausland);
 * alles davor sind Anschriftzeilen. Liefert null, wenn keine PLZ-/Ortszeile zu erkennen ist.
 */
export function anschriftZuEmpfaenger(text: string): Empfaenger | null {
  const zeilen = (text ?? '').split('\n').map((z) => z.trim()).filter(Boolean);
  if (zeilen.length < 2) return null;
  let land = '';
  const letzte = zeilen[zeilen.length - 1];
  if (!/\d/.test(letzte) && letzte === letzte.toUpperCase() && zeilen.length >= 3 && !/^(DEUTSCHLAND|GERMANY)$/.test(letzte)) {
    land = letzte;
    zeilen.pop();
  } else if (/^(DEUTSCHLAND|GERMANY)$/i.test(letzte)) zeilen.pop();
  const ortZeile = zeilen.pop() ?? '';
  const m = /^(?:D-)?([A-Z0-9-]{3,10})\s+(.+)$/i.exec(ortZeile);
  if (!m || !/\d/.test(m[1])) return null;
  return { zeilen, plz: m[1], ort: m[2].trim(), ...(land ? { land } : {}) };
}

/** Blob → reines Base64 (ohne data:-Präfix). */
export function blobZuBase64(blob: Blob): Promise<string> {
  return new Promise((ok, fehler) => {
    const r = new FileReader();
    r.onload = () => ok(String(r.result).replace(/^data:[^,]*,/, ''));
    r.onerror = () => fehler(new Error('Datei konnte nicht gelesen werden'));
    r.readAsDataURL(blob);
  });
}
